<template>
  <footer class="h5-footer">
    <div class="h5Footer-item"
         v-for="(item,index) in footers"
         :key="index"
         :class="{'h5Footer-item--active':index===activeIndex}"
         @click.stop="handleClick(index)">
      <span class="h5Footer-item__icon">
        <svg viewBox="0 0 1024 1024"
             version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             style="display: block;width:100%;height:100%;">
          <path v-if="item.icon==='chanpin'"
                d="M1024 789.333333c0 129.6-105.045333 234.666667-234.666667 234.666667-129.6 0-234.666667-105.045333-234.666666-234.666667v-170.645333A64 64 0 0 1 618.688 554.666667H789.333333c129.6 0 234.666667 105.045333 234.666667 234.666666z m-85.333333 0c0-82.304-66.858667-149.333333-149.333334-149.333333h-149.333333v149.333333c0 82.304 66.858667 149.333333 149.333333 149.333334 82.304 0 149.333333-66.858667 149.333334-149.333334zM0 789.333333c0-129.621333 105.066667-234.666667 234.666667-234.666666h170.645333A64 64 0 0 1 469.333333 618.688V789.333333c0 129.621333-105.066667 234.666667-234.666666 234.666667-129.621333 0-234.666667-105.066667-234.666667-234.666667z m85.333333 0c0 82.474667 67.029333 149.333333 149.333334 149.333334 82.474667 0 149.333333-67.029333 149.333333-149.333334v-149.333333h-149.333333c-82.474667 0-149.333333 67.029333-149.333334 149.333333z m938.666667-554.666666c0 129.621333-105.066667 234.666667-234.666667 234.666666h-170.645333A64 64 0 0 1 554.666667 405.312V234.666667c0-129.621333 105.066667-234.666667 234.666666-234.666667 129.621333 0 234.666667 105.066667 234.666667 234.666667z m-85.333333 0c0-82.474667-67.029333-149.333333-149.333334-149.333334-82.474667 0-149.333333 67.029333-149.333333 149.333334v149.333333h149.333333c82.474667 0 149.333333-67.029333 149.333334-149.333333zM0 234.666667C0 105.066667 105.045333 0 234.666667 0c129.6 0 234.666667 105.045333 234.666666 234.666667v170.645333A64 64 0 0 1 405.312 469.333333H234.666667C105.066667 469.333333 0 364.288 0 234.666667z m85.333333 0c0 82.304 66.858667 149.333333 149.333334 149.333333h149.333333v-149.333333c0-82.304-66.858667-149.333333-149.333333-149.333334-82.304 0-149.333333 66.858667-149.333334 149.333334z"
                fill="currentColor" />

          <path v-if="item.icon==='guanli'"
                d="M469.333333 896H170.666667V128h426.666666v213.333333a42.666667 42.666667 0 0 0 42.666667 42.666667h213.333333v85.333333a42.666667 42.666667 0 0 0 85.333334 0V341.333333a42.666667 42.666667 0 0 0-12.373334-30.293333l-256-256A42.666667 42.666667 0 0 0 640 42.666667H128a42.666667 42.666667 0 0 0-42.666667 42.666666v853.333334a42.666667 42.666667 0 0 0 42.666667 42.666666h341.333333a42.666667 42.666667 0 0 0 0-85.333333z m213.333334-707.84L793.173333 298.666667H682.666667z" />
          <path d="M959.573333 746.666667l-98.56-170.666667a42.666667 42.666667 0 0 0-37.12-21.333333h-197.12a42.666667 42.666667 0 0 0-37.12 21.333333l-98.56 170.666667a42.666667 42.666667 0 0 0 0 42.666666l98.56 170.666667a42.666667 42.666667 0 0 0 37.12 21.333333h197.12a42.666667 42.666667 0 0 0 37.12-21.333333l98.56-170.666667a42.666667 42.666667 0 0 0 0-42.666666zM799.146667 896h-147.626667l-73.813333-128 73.813333-128h147.626667l73.813333 128z" />
          <path d="M725.333333 768m-42.666666 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z" />
          <path d="M426.666667 256H298.666667a42.666667 42.666667 0 0 0 0 85.333333h128a42.666667 42.666667 0 0 0 0-85.333333zM426.666667 426.666667H298.666667a42.666667 42.666667 0 0 0 0 85.333333h128a42.666667 42.666667 0 0 0 0-85.333333zM426.666667 597.333333H298.666667a42.666667 42.666667 0 0 0 0 85.333334h128a42.666667 42.666667 0 0 0 0-85.333334z"
                fill="currentColor" />

          <path v-if="item.icon==='lianxi'"
                d="M252.768 160.768a90.88 90.88 0 0 0-9.28 5.76 217.6 217.6 0 0 0-27.904 24.192 429.248 429.248 0 0 0-36.288 41.504c-9.6 11.296-19.52 37.92-20.032 55.04l-0.576 4.832c-2.944 30.72 3.04 69.792 18.944 115.008 28.16 80.064 83.136 164.256 165.792 250.56 84.864 88.64 169.696 145.472 252.32 171.808 24.64 7.84 48.096 12.608 70.112 14.432a38.944 38.944 0 0 1-6.4 77.6 395.776 395.776 0 0 1-87.36-17.856c-95.488-30.4-191.264-94.304-284.928-192.096-90.144-94.176-151.008-187.68-182.976-278.592-19.616-55.744-27.072-105.952-23.232-146.208 0.192-1.984 0.416-3.84 0.64-5.44 1.632-33.024 17.6-75.104 37.024-97.824a506.048 506.048 0 0 1 41.856-47.776 291.744 291.744 0 0 1 38.336-32.96c33.28-23.296 63.904-29.856 88.32-15.36 20.992 9.6 38.4 37.376 76.768 115.52l9.6 19.776a3785.728 3785.728 0 0 1 54.24 118.272c10.368 23.488 7.584 55.104-6.752 76.384l-44.416 65.92c1.664 3.84 4.544 8.928 8.64 15.008 10.912 16.384 28.864 37.76 53.792 63.136 34.208 34.848 64.32 58.4 89.28 70.816 5.12 2.56 9.696 4.448 13.536 5.696l57.408-42.4c20.896-14.112 52.032-17.376 75.264-8l9.536 3.776a3480.288 3480.288 0 0 1 100.32 42.176c7.84 3.488 15.36 6.848 22.464 10.112 70.08 32.032 95.456 47.168 105.056 68.064 23.072 43.904-2.368 89.152-69.6 148.48a735.232 735.232 0 0 1-24.64 20.768 38.944 38.944 0 0 1-48.32-61.088 657.664 657.664 0 0 0 21.44-18.08c17.088-15.104 31.68-30.592 41.248-43.52 3.072-4.192 5.504-7.936 7.168-11.008a233.216 233.216 0 0 0-9.28-5.44c-13.28-7.424-32-16.64-55.456-27.36a3025.536 3025.536 0 0 0-128.8-54.592c0.512 0.224-3.392 0.64-2.88 0.256l-74.752 50.432a39.744 39.744 0 0 1-20.928 6.656c-14.24 0.32-32.48-4.8-53.44-15.2-33.28-16.544-70.08-45.12-110.176-85.984-66.848-68.096-94.08-117.504-83.328-154.56 1.28-4.416 3.04-8.32 5.728-12.48l50.56-75.104a77.216 77.216 0 0 0-4.32-11.424 4172.448 4172.448 0 0 0-48.8-105.984c-3.2-6.656-6.272-13.056-9.28-19.2a1091.04 1091.04 0 0 0-32.864-62.72 289.28 289.28 0 0 0-8.384-13.728z"
                fill="currentColor" />
        </svg>
      </span>
      <p class="h5Footer-item__text">{{item.title}}</p>
      <ul class="h5Footer-menu">
        <li class="h5Footer-menu__item"
            v-for="(menuItem,menuIndex) in item.menuLists"
            :key="menuIndex">
          <router-link :to="menuItem.link"
                       class="h5Footer-menu__item_link"
                       v-if="menuItem.link">{{menuItem.text}}</router-link>
          <a href="javascript:void(0)"
             class="h5Footer-menu__item_link"
             v-else>{{menuItem.text}}</a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: -1,
      footers: [
        {
          icon: "chanpin",
          title: "产品",
          menuLists: [
            { text: "大模型AI", link: "/portal/lm" },
            { text: "AI平台", link: "/portal/ai" },
            { text: "AI教育", link: "/portal/edu" },
            { text: "应用引擎", link: "/portal/lmaes" },
          ]
        },
        {
          icon: "guanli",
          title: "关于公司",
          menuLists: [
            { text: "关于公司", link: "/more/introduction" },
            { text: "新闻资讯", link: "/news" }
          ]
        },
        {
          icon: "lianxi",
          title: "联系我们",
          menuLists: []
        }
      ]
    };
  },
  mounted: function() {
    window.addEventListener("click", this.changeActiveIndex);
  },
  beforeDestroy: function() {
    window.removeEventListener("click", this.changeActiveIndex);
  },
  methods: {
    changeActiveIndex() {
      this.activeIndex = -1;
    },
    handleClick(index){
      this.activeIndex = index;
      if(index === 2) {
        this.$router.push({
          path:'/more/introduction',
          query:{activeName:6}
        });
      }
    }
  },
  watch: {
    "$route.path": function() {
      this.activeIndex = -1;
    }
  }
};
</script>

<style scoped>
.h5-footer {
  position: fixed;
  bottom: 0;
  z-index: 2;
  display: table;
  width: 100vw;
  height: 10.666666666666666vw;
  font-size: 3.2vw;
  color: #fff;
  background: #1c1b23;
  table-layout: fixed;
}
.h5Footer-item {
  position: relative;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}
.h5Footer-item--active {
  color: #00d5df;
}

.h5Footer-item__icon {
  display: inline-block;
  width: 3.7333333333333334vw;
  height: 3.7333333333333334vw;
}
.h5Footer-item__icon_img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.h5Footer-menu {
  position: absolute;
  right: 0;
  bottom: 100%;
  display: none;
  width: fit-content;
  min-width: 100%;
  padding: 2.9vw 0;
  background: #17212f;
}

.h5Footer-item--active .h5Footer-menu {
  display: block;
}

.h5Footer-menu:empty {
  display: none;
}
.h5Footer-menu__item {
  line-height: 2;
  color: #a6b7ce;
}
.h5Footer-menu__item:hover {
  color: #e7f1ff;
}
.h5Footer-menu__item_link {
  color: inherit;
}
svg {
  display: block;
  width: 100%;
  height: 100%;
  stroke: currentColor;
  fill: currentColor;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/home-footer.vue